import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateEditMeetingRoomProperties,
  resetMeetingRoomForm,
  selectMeetingRoom,
} from '../../../../actions/meetingRoom';
import { redirectToInternalLink } from 'businessLogic/redirector';
import { forceValidation } from '../../../../businessLogic/validation.js';
import { hideGlobalMessage } from '../../../../actions/globalMessage';
import { showEditMeetingRoomModal } from '../../../../actions/modal';
import { updateSearchColumn } from '../../../../actions/shared';
import { getMRByIdWithSearchTerm } from 'actions/organisation';

import Info from '../../info';
export default function RightPanel(props) {
  const dispatch = useDispatch();
  const [isUpdateMRSaving, setIsUpdateMRSaving] = useState(false);

  useEffect(() => {
    // Force validation of the input fields
    let validation = () => {
      forceValidation(undefined, undefined, 'editMRForm');
    };
    setTimeout(validation, 50);
  }, []);

  const updateCreateMR = (e) => {
    let areThereErrors = forceValidation(undefined, undefined, 'editMRForm');
    if (!areThereErrors && !window.$(e.target).hasClass('disable')) {
      let cb = (result, response) => {
        if (result) {
          //if there's no failure
          // Update searchTerm if it's still in search
          let lastCb = (data) => {
            dispatch(updateSearchColumn(null));
            dispatch(showEditMeetingRoomModal(false));
            dispatch(selectMeetingRoom(data));
          };
          dispatch(
            getMRByIdWithSearchTerm(
              props.selectedMeetingRoom.id,
              props.selectedMeetingRoom.organisationNetworkId,
              lastCb
            )
          );
        } else {
          setIsUpdateMRSaving(false);
        }
      };

      setIsUpdateMRSaving(true);
      // Add check and see which option should be sent
      let postCallOption = props.meetingRoomForm.postCallOption;
      let callerGuestUrl = props.meetingRoomForm.callerGuestUrl;
      let callProviderUrl = props.meetingRoomForm.callProviderUrl;
      let postCallUrl = props.meetingRoomForm.postCallUrl;

      if (props.meetingRoomForm.postCallOption === 1 && props.meetingRoomForm.postCallUrl == '') {
        postCallOption = 0;
      }
      if (props.meetingRoomForm.postCallOption === 2) {
        if (props.meetingRoomForm.callProviderUrl == '' && props.meetingRoomForm.callerGuestUrl == '') {
          postCallOption = 0;
        }
      }
      // Need to check what post option and submit url server requires
      let newEditMeetingRoomPayload = {
        name: props.meetingRoomForm.name,
        videoCallQualityId: props.meetingRoomForm.videoCallQualityId,
        postCallOption: postCallOption,
        postCallUrl: postCallOption == 1 ? postCallUrl : null,
        callProviderUrl: postCallOption == 2 ? callProviderUrl : null,
        callerGuestUrl: postCallOption == 2 ? callerGuestUrl : null,
        organisationNetworkId: props.meetingRoomForm.organisationNetworkId,
      };

      // Send the get call
      dispatch(updateEditMeetingRoomProperties(props.meetingRoomForm.id, newEditMeetingRoomPayload, cb));
    }
  };

  const cancelEditMR = () => {
    if (isUpdateMRSaving) {
      //when saving we dont want to cancel
      return;
    }
    if (window.$('.global-message.color-bad-things-bg:visible').length > 0) dispatch(hideGlobalMessage());
    dispatch(showEditMeetingRoomModal(false));
    dispatch(resetMeetingRoomForm());
  };

  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull disable';
  let cancelClass =
    'ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull';
  return (
    <div>
      <div className="ui actions mrbl max-width noTopMarginTablet">
        <button
          type="button"
          onClick={updateCreateMR}
          data-group="editMRForm"
          className={isUpdateMRSaving ? saveClasses + ' loading' : saveClasses}
        >
          {APP.LANGUAGE.Save}
          <i className="checkmark icon" />
        </button>
        <button type="button" onClick={cancelEditMR} className={cancelClass}>
          <i className="remove icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
      <div className="mrtl">
        <Info paragraphs={[APP.LANGUAGE.EditMeetingRoomProperties.DetailPart1]} />
      </div>
    </div>
  );
}
